module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5045ddf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideTabContainer.vue
// module id = 1032
// module chunks = 40